import types from './types';

import { Moment } from 'moment';
import TrackingModel from 'src/model/trackingInfo.model';
import trackingService from 'src/services/tracking';
import DateRangeModel from 'src/model/dateRange.model';

import { paginationActions } from 'src/store/modules/pagination';

interface ITrackFilters {
  dates: DateRangeModel | null;
  search: string;
  sortBy: string;
  sortIn: 'ASC' | 'DESC' | 'AUTO';
}

interface IPagination {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}

const getTracking = (filters: ITrackFilters, pagination: IPagination) => {
  return (dispatch: any) => {
    dispatch(getTrackingIsPending(true));
    dispatch(setDatesFilters(filters.dates ? filters.dates : null));
    trackingService
      .getTracking(filters, pagination)
      .then((response: any) => {
        dispatch(clearTracking());
        if (response.data) {
          const { pageNumber, pageSize, totalElements, totalPages } = response;
          dispatch(setTrackingContent(response.data));
          dispatch(
            setTrackingPagination({
              pageNumber,
              pageSize,
              totalElements,
              totalPages
            })
          );
          dispatch(getTrackingIsPending(false));
        } else {
          setTrackingPagination({
            pageNumber: 0,
            pageSize: 0,
            totalElements: 0,
            totalPages: 0
          });
        }
      })
      .catch((error: any) => {
        dispatch(setError('getTracking', error));
        dispatch(getTrackingIsPending(false));
      });
  };
};

const setTrackingContent = (content: TrackingModel[]) => {
  return { type: types.SET_CONTENT, payload: content };
};

const setTrackingPagination = (pagination: IPagination) => {
  return { type: types.TRACKING_PAGINATION, payload: pagination };
};

const getTrackingIsPending = (isPending: boolean) => {
  return { type: types.GET_TRACKING_IS_PENDING, payload: isPending };
};

const setDatesFilters = (dates: { start: Moment; end: Moment }) => {
  return { type: types.SET_DATES_FILTER, payload: dates };
};

const clearTracking = () => {
  return { type: types.CLEAR_ALL };
};

const setError = (action: string, error: any) => {
  return {
    type: types.TRACKING_ERROR,
    payload: { caller: action, error }
  };
};

export default {
  getTracking,
  setTrackingPagination
};
